import React, { useEffect } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { getCompanyName, isAuthenticated } from './auth';
import { trackPageView } from './analytics';
import LoginPage from './components/LoginPage';
import Sidebar from './components/Sidebar';
import InvoicesManagement from './components/InvoicesManagement';
import PastDueInvoices from './components/PastDueInvoices';
import QuotesManagement from './components/QuotesManagement';
import QuotesUpdate from './components/QuotesUpdate';
import UpcomingTests from './components/UpcomingTests';
import UpcomingTestsUpdate from './components/UpcomingTestsUpdate';
import BusinessImpact from './components/BusinessImpact';

// Fires a GA pageview on every route change. Filtering (login route, demo
// user, dev mode) lives inside trackPageView itself.
const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
  return null;
};

const ProtectedLayout = () => {
  const location = useLocation();

  useEffect(() => {
    const companyName = getCompanyName();
    if (companyName) {
      document.title = companyName;
    }
  }, []);

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return (
    <div className="flex">
      <Sidebar />
      <main className="flex-1 p-6 bg-blue-50 min-h-screen">
        <Routes>
          <Route path="/" element={<InvoicesManagement />} />
          <Route path="/past-due" element={<PastDueInvoices />} />
          <Route path="/quotes" element={<QuotesManagement />} />
          <Route path="/quotes-update" element={<QuotesUpdate />} />
          <Route path="/upcoming-tests" element={<UpcomingTests />} />
          <Route path="/upcoming-tests-update" element={<UpcomingTestsUpdate />} />
          <Route path="/business-impact" element={<BusinessImpact />} />
        </Routes>
      </main>
    </div>
  );
};

function App() {
  return (
    <Router>
      <RouteTracker />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={<ProtectedLayout />} />
      </Routes>
    </Router>
  );
}

export default App;
